import { myAxios } from "./axios"

export function getCollections(payload, { page, perPage }) {
    let config = {
        params: {
            page,
            perPage,
            ...(payload || {})
        },
    }
    return myAxios.get("/pools/"+payload.poolId+"/hours-collections", config)
}


export function getCollection(id) {
    return myAxios.get("/hours-collections/" + id)
}

export function addCollection(data) {
    return myAxios.post("/hours-collections/create", data)
}

export function createNegativeHoursCollection(data) {
    return myAxios.post("/hours-collections/create-negative-hours", data)
}

export function editCollection(id, data) {
    return myAxios.put("/hours-collections/" + id + "/update", data)
}

export function deleteCollection(id) {
    return myAxios.delete("/hours-collections/" + id + "/delete")
}
